import { render } from "./TheOverlay.vue?vue&type=template&id=477f563b&scoped=true"
import script from "./TheOverlay.vue?vue&type=script&lang=js"
export * from "./TheOverlay.vue?vue&type=script&lang=js"

import "./TheOverlay.vue?vue&type=style&index=0&id=477f563b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-477f563b"

export default script